import { proNavigator } from "single-spa/react-app/ProNavigator";
import type { IRouterState, IRouterStateWithName } from "single-spa/react-app/router/IRouterState";

import { canNavigate } from "./canNavigate";

export function getActiveSibling(toState: IRouterStateWithName, toParams: FixmeType) {
    const currentModule = proNavigator.getStateModule(toState);

    const siblings = proNavigator
        .getModuleStates(currentModule)
        .filter((s) => !s.abstract)
        .filter((s) => canNavigate(s, toParams));

    if (siblings.length === 0) {
        return null;
    }

    const notHomeSiblings = siblings.filter((s) => !proNavigator.isHomePage(s));
    if (notHomeSiblings.length > 0) {
        return notHomeSiblings[0].name;
    }
    return siblings[0].name;
}

export function getHomePage(toState: IRouterState, toParams: FixmeType) {
    const isGrow = proNavigator.isLeadGenerator(toState);
    const growHomeState = proNavigator.getState("growHomepage");

    if (isGrow && canNavigate(growHomeState, toParams)) {
        return growHomeState;
    }

    return proNavigator.getState("digitalsuite_websiteanalysis_home");
}
